import { put, all, select } from 'redux-saga/effects'

export function* initNonXISInjectionsWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/xtract/nonXisInjectionsWindow',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initPatientDisplay(action) {
  const streams = yield select(state => state.streams)
  if (streams.PATIENT_LOCK != null) {
    // there is already a lock stream open that needs to be closed
    yield put({
      type: 'CLOSE_STREAM',
      name: 'PATIENT_LOCK'
    })
  }
  yield all([
    put({
      type: 'XTRACT_API_CALL',
      resource: 'patient/' + action.patientId + '/xtract/loadPatientDisplay',
      method: 'read',
      obj: null,
      id: null
    }),
    // patient read call is separate for quick header load
    put({
      type: 'XTRACT_API_CALL',
      resource: 'patient/' + action.patientId,
      method: 'read',
      obj: null,
      id: null
    }),
    // and demo graphic call is separate yet again.
    put({
      type: 'XTRACT_API_CALL',
      resource: 'patient_demographics/' + action.patientId,
      method: 'read',
      obj: null,
      id: null
    }),
    put({
      type: 'XTRACT_API_CALL',
      resource: 'patient/' + action.patientId + '/lock',
      method: 'stream',
      obj: null,
      id: action.patientId
    })
  ])
}

export function* initQuestionnaireReviewWindow(action) {
  // call an action to make an API call to load questionnaire details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/questionnaire_due',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initQuestionnaireHistoryWindow(action) {
  // call an action to make an API call to load questionnaire details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/questionnaire/answered',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initVialMixingWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'extract/for_treatment',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initOrderEntryWindow(action) {
  // call actions to make an API call to load vial mixing details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/xtract/orderEntryWindow',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* resetInjectionData(action) {
  yield all([
    put({ type: 'CLEAR_INJECTION_DATA' }),
    put({
      type: 'XTRACT_API_CALL',
      resource: 'patient/' + action.patientId + '/xtract/loadInjectionData',
      method: 'read',
      obj: null,
      id: null
    })
  ])
}

export function* initActivateVialsWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/vial',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initQuestionnaireWindow(action) {
  // call an action to make an API call to load questionnaire details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/questionnaire_due',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initPrescriptionWindow(action) {
  // call an action to make an API call to load prescription details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/prescription',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initPurchaseOrderWindow(action) {
  // call an action to make an API call to load prescription details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/purchase_order',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initInjectionGraphWindow(action) {
  // call an action to make an API call to load injection details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/injection',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initInjectionWindow(action) {
  // call an action to make an API call to load injection details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'config',
    method: 'search',
    obj: { equal: { name: 'reaction_names' } },
    id: null
  })
}

export function* initInjectionListWindow(action) {
  // call an action to make an API call to load injection details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'config',
    method: 'search',
    obj: { equal: { name: 'reaction_names' } },
    id: null
  })
}

export function* initSkintestWindow(action) {
  // call an action to make an API call to load skintest details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/skintest',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initPatientDetailsWindow(action) {
  // call an action to make an API call to load patient details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/xtract/patientDetailsWindow',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initInjAdjustWindow(action) {
  // call an action to make an API call to load patient details
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/xtract/injAdjustWindow',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initTrackingWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/xtract/trackingWindow',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initImmunotherapySummaryWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource:
      'patient/' + action.patientId + '/xtract/immunotherapySummaryWindow',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initStandardInjectionWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/xtract/standardInjectionWindow',
    method: 'read',
    obj: null,
    id: null
  })
}

export function* initDirectMessageWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'patient/' + action.patientId + '/contact_log',
    method: 'read',
    obj: null,
    id: null
  })
}
